export default __webpack_public_path__ + "static/media/jpmc_nsaw_v.8640eecf.png";